export class Lot {
    
    public id: string;
    public product_id: string;
    public name: string;   
    public until_date: Date;
   // public deleted: boolean
    
    constructor() {}
}